import type { ReactNode } from 'react';

export const symbol_settings_bluetooth: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M451-488 278-315q-9 9-21 9t-21-9q-9-9-9-21t9-21l203-203-203-203q-9-9-9-21t9-21q9-9 21-9t21 9l173 173v-272q0-14 9.5-22t20.5-8q5 0 10.5 2t10.5 7l172 172q5 5 7 10t2 11q0 6-2 11t-7 10L523-560l151 151q5 5 7 10t2 11q0 6-2 11t-7 10L502-195q-5 5-10.5 7t-10.5 2q-11 0-20.5-8t-9.5-22v-272Zm60 198 100-98-100-100v198Zm0-342 100-100-100-98v198ZM284.5-8.5Q276-17 276-30t8.5-21.5Q293-60 306-60t21.5 8.5Q336-43 336-30t-8.5 21.5Q319 0 306 0t-21.5-8.5Zm174 0Q450-17 450-30t8.5-21.5Q467-60 480-60t21.5 8.5Q510-43 510-30t-8.5 21.5Q493 0 480 0t-21.5-8.5Zm170 0Q620-17 620-30t8.5-21.5Q637-60 650-60t21.5 8.5Q680-43 680-30t-8.5 21.5Q663 0 650 0t-21.5-8.5Z"
		/>
	</svg>
);
